<script setup>
import { ref, onBeforeMount } from 'vue'
import { useCustomChart } from '@/composable/customChart.js'
import { getFontSize, numberFormatter, getThisYear } from '@/js/customChart.js'

import { useNavigatorStore } from '@/store/navigator'
const navigatorStore = useNavigatorStore()

const chartOptions = {
  padding: 10,
  columns: 2,
  rows: 11,
}
const { canvasWrap, initCustomChart } = useCustomChart(drawChart, chartOptions, false)

import { getPipeLineBalanceList } from '@/api/dashboard'

// props
const props = defineProps({
  gridArea: Object,
  width: Number,
  height: Number
})

const summary = {
  value: '(from the 1st FCST of the Year)',
  unit: '',
  coords: [1, 9],
  style: {
    fillStyle: 'royalblue',
  }
}

// data
const fetchedData = ref()

// lifecycle
onBeforeMount(async () => {
  try {
    const result = await getPipeLineBalanceList({
      fs_year: getThisYear(),
    })
    if (!result.rtn.length) return
    fetchedData.value = result.rtn.at(0)
    initCustomChart()
  } catch (err) {
    console.error(err)
  }
})

function drawChart(canvasInfo ,ctx) {
  const mappedData = Object.entries(fetchedData.value)
    .filter(([key]) => key !== 'bizdate')
    .map(([key, value], index) => {
      const prefix = {
        thisweekamt: ``,
        lastdiffamt: `WoW `,
        firstdiffamt: `Δ `
      }
      const coords = {
        thisweekamt: [1, 2],
        lastdiffamt: [1, 5],
        firstdiffamt: [1, 7]
      }
      const obj = {
        value: `${prefix[key]}${numberFormatter(value)}원`,
        coords: coords[key],
      }
      const fontSizes = {
        thisweekamt: getFontSize(canvasInfo, props.gridArea, navigatorStore.isMobile ? 20 : 13),
        lastdiffamt: getFontSize(canvasInfo, props.gridArea, navigatorStore.isMobile ? 15 : 8),
        firstdiffamt: getFontSize(canvasInfo, props.gridArea, navigatorStore.isMobile ? 15 : 8)
      }
      obj.style = {
        fillStyle: key === 'thisweekamt' ? 'black' : getFontColor(value),
        font: `bold ${fontSizes[key]}px suit-m`
      }
      return obj
    })
  summary.style.font = `bold ${getFontSize(canvasInfo, props.gridArea, navigatorStore.isMobile ? 11 : 6)}px suit-m`
  mappedData.push(summary)
  mappedData.forEach(datum => {
    drawText(canvasInfo, ctx, datum)
  })
}

function drawText(canvasInfo, ctx, { value, unit = '', coords: [ x, y ], style = {} }) {
  const coords = [
    canvasInfo.cellWidth * x + canvasInfo.padding,
    canvasInfo.cellHeight * y + canvasInfo.padding,
  ]
  const initStyle = {
    textAlign: 'center',
    textBaseline: 'middle',
    fillStyle: 'black',
  }
  const mergedStyle = {
    ...initStyle,
    ...style
  }
  if (Object.keys(mergedStyle).length) {
    Object.entries(mergedStyle).forEach(([key, value]) => {
      ctx[key] = value
    }) 
  }
  ctx.fillText(`${value}${unit}`, coords[0], coords[1])
}

function getFontColor(value) {
  return value > 0 ? 'royalblue' : 'red'
}
</script>

<template>
  <article :ref="(element) => canvasWrap = element" :style="{ width: `${width}px`, height: `${height}px` }">
    <canvas id="FinalBalanceFCST"></canvas>
  </article>
</template>

<style scoped>
article {
  display: flex;
  justify-content: center;
  flex: 1 0 auto;
}
#FinalBalanceFCST {
  width: 100%;
}
</style>